import { render, staticRenderFns } from "./fb.vue?vue&type=template&id=5802105a&scoped=true&"
import script from "./fb.vue?vue&type=script&lang=js&"
export * from "./fb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5802105a",
  null
  
)

export default component.exports